import React, { Fragment } from 'react'
import { Modal } from 'react-bootstrap'
import { GrClose } from 'react-icons/gr'
const ShowMoreAchievementsContent = (props) => {
    return (
        <Fragment>
            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="lg"
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                    </Modal.Title>
                    <GrClose onClick={props.onHide} className='close-popup-btn' />
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    )
}

export default ShowMoreAchievementsContent